(() => {
  document.querySelectorAll('.cb-review-banner').forEach(banner => {
    const button = banner.querySelector('[data-cb-open-service-reviews]');
    if (!button || button.dataset.cbBound) return;
    button.dataset.cbBound = 'true';
    if (!banner.hasAttribute('data-cb-static-reviews')) {
      button.addEventListener('click', () => banner.querySelector('.lipscore-service-review-testimonial-content')?.click());
      return;
    }

    const slides = [...banner.querySelectorAll('[data-cb-review-slide]')];
    const dots = [...banner.querySelectorAll('[data-cb-review-select]')];
    let current = 0;
    let timer;
    let inView = false;
    let manual = false;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const show = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== current)));
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
    };
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (inView && !manual && !reducedMotion.matches && !document.hidden && !banner.matches(':hover, :focus-within')) {
        timer = setInterval(() => show(current + 1), 7000);
      }
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => { manual = true; stop(); show(index); }));
    banner.querySelector('[data-cb-review-dots]').hidden = false;
    banner.addEventListener('mouseenter', stop);
    banner.addEventListener('mouseleave', start);
    banner.addEventListener('focusin', stop);
    banner.addEventListener('focusout', () => requestAnimationFrame(start));
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener('change', start);
    new IntersectionObserver(entries => { inView = entries[0].isIntersecting; start(); }).observe(banner);

    const live = banner.querySelector('[data-cb-review-live]');
    const status = banner.querySelector('[data-cb-review-status]');
    const waitForWidget = () => new Promise((resolve, reject) => {
      const ready = () => live.querySelector('.lipscore-service-review-testimonial-content');
      if (ready()) return resolve(ready());
      const observer = new MutationObserver(() => {
        const widget = ready();
        if (widget) { clearTimeout(timeout); observer.disconnect(); resolve(widget); }
      });
      const timeout = setTimeout(() => { observer.disconnect(); reject(new Error('Review widget timeout')); }, 15000);
      observer.observe(live, { childList: true, subtree: true });
    });
    button.addEventListener('click', async () => {
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.loading;
      status.hidden = false;
      try {
        if (!live.childNodes.length) live.appendChild(banner.querySelector('[data-cb-review-widget]').content.cloneNode(true));
        await window.cbLoadLipscore();
        const widget = await waitForWidget();
        status.hidden = true;
        widget.click();
        // The native trigger is hidden, so restore focus to the visible button.
        const modal = document.getElementById('lipscore-modal');
        if (modal) {
          const restore = new MutationObserver(() => {
            if (modal.getClientRects().length) return;
            restore.disconnect();
            button.focus({ preventScroll: true });
          });
          restore.observe(modal, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        }
      } catch {
        status.textContent = status.dataset.error;
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  });
})();
